import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Treasury from './Components/Treasury';
import Home from './Components/Home';
import Error from './Components/Error';
import Header from './Components/Header'
import Footer from './Components/Footer'
import Swap from './Components/Swap'
import Liquidity from './Components/Liquidity'
import FindLiquidity from './Components/FindLiquidity'
import AddLiquidity from './Components/AddLiquidity'
import RemoveLiquidity from './Components/RemoveLiquidity'
import Stake from './Components/Stake'
import Farms from './Components/Farms'
import Rewards from './Components/Rewards'
import Iro from './Components/Iro'
import SocialIcons from './Components/SocialIcons'
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';


function App() {
  return (
    <>
      <Router>
        <Header />
        <SocialIcons />
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/treasury" >
            <Treasury />
          </Route>
          <Route path="/swap" >
            <Swap />
          </Route>
          <Route path="/liquidity" >
            <Liquidity />
          </Route>
          <Route path="/find-liquidity" >
            <FindLiquidity />
          </Route>
          <Route path="/add-liquidity" >
            <AddLiquidity />
          </Route>
          <Route path="/remove-liquidity" >
            <RemoveLiquidity />
          </Route>
          <Route path="/stake" >
            <Stake />
          </Route>
          <Route path="/farms" >
            <Farms />
          </Route>
          <Route path="/rewards" >
            <Rewards />
          </Route>
          <Route path="/iro" >
            <Iro />
          </Route>
          <Route  >
            <Error />
          </Route>
        </Switch>

        <Footer />
      </Router>
    </>
  );
}

export default App;
